import { DvAxiosRequest } from '../../components/utility/dvGeneralUtilities';
import CamelcaseKeys from 'camelcase-keys';
import SnakeCaseKeys from 'snakecase-keys';

// ----------------- log in/out stuff --------------
const loginService = (username, password, rememberMe) => {
  const requestOptions = {
    url: 'login',
    method: 'post',
    data: SnakeCaseKeys({
      email: username,
      password: password,
      rememberMe: rememberMe,
    })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { deep: true })
    };
  });
};

const loginWithOtpService = (otpCode, username, password, rememberMe) => {
  const requestOptions = {
    url: 'loginWithOtp',
    method: 'post',
    data: SnakeCaseKeys({
      otp: otpCode,
      email: username,
      password,
      rememberMe
    }, { deep: true })
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { deep: true })

    };
  });
};

const refreshTokenService = () => {
  const requestOptions = {
    url: 'refresh-token',
    method: 'put'
  };
  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { deep: true })

    };
  });
};

const logoutService = () => {
  const requestOptions = {
    url: 'logout',
    method: 'post',
  };

  return DvAxiosRequest(requestOptions, function (response) {
    return {
      status: 1,
      results: CamelcaseKeys(response.data, { deep: true })
    };
  });
};



// ---------------- other stuff -------------
const getCurrentUserService = () => {
  const requestOptions = {
      url: `users/current`,
      method: 'get'
    };
    return DvAxiosRequest(requestOptions, function (response) {
      return CamelcaseKeys(response.data, { deep: true });
    });
};


// ----- zoho and icmd stuff
const getIcmdAuthStatus = () => {
  const requestOptions = {
    url: "ehrAdmin/emails/authStatus",
    method: "get",
  };

  return DvAxiosRequest(requestOptions, function(response) {
    return {
      status: 1,
      authStatus: CamelcaseKeys(response.data, {deep:true})
    };
  });
};

const initializeIcmdAuth = () => {
  const requestOptions = {
    url: "ehrAdmin/emails/authInit",
    method: "post",
  };

  return DvAxiosRequest(requestOptions, function(response) {
    return {
      status: 1,
      authInfo: CamelcaseKeys(response.data, {deep:true})
    };
  });
};

export {
  loginService, logoutService, refreshTokenService, loginWithOtpService, getCurrentUserService,
  getIcmdAuthStatus, initializeIcmdAuth
};